import { IPropostaItemDTO } from '../dto/proposta-item-dto';
import { Observable } from 'rxjs';
import { Tso } from 'ts-odata';
import { ApiResultado } from '../models/api-resultado';
import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { IProposta } from '../models/proposta';
import { PropostasApi } from '../api/propostas.api';

@Injectable()
export class PropostaItemService extends ServiceBase<IProposta, IPropostaItemDTO> {
  constructor(api: PropostasApi) {
    super(api);
  }

  tabelaPropostas(query: Tso): Observable<ApiResultado<IPropostaItemDTO>> {
    query.baseUri = 'tabela-proposta/Z7';
    return this.odata(query);
  }

  formaPagamentos(query: Tso): Observable<ApiResultado<IPropostaItemDTO>> {
    query.baseUri = 'tabela-proposta/24';
    return this.odata(query);
  }
}
